import React from 'react';
import { Fieldset } from '@fourthwall/components';
import { ImageFields } from '../../../../../Post/modules/ImageFields';
export const ImageFieldsComponent = ({ imageFieldName, imageResourceIdFieldName, image, }) => {
    return (React.createElement(Fieldset.Row, null,
        React.createElement(Fieldset.Item, null,
            React.createElement(ImageFields, { imageFieldName: imageFieldName, imageResourceIdFieldName: imageResourceIdFieldName, image: image }))));
};
